import { render, staticRenderFns } from "./BlocklyWorkspace.vue?vue&type=template&id=14743fa8&scoped=true&"
import script from "./BlocklyWorkspace.vue?vue&type=script&lang=js&"
export * from "./BlocklyWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyWorkspace.vue?vue&type=style&index=0&id=14743fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14743fa8",
  null
  
)

export default component.exports